import {Injectable} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class FormHelperService {
  constructor(private toastr: ToastrService) {}

  /* eslint-disable @typescript-eslint/no-explicit-any */
  handleServerErrors(form: UntypedFormGroup | any, errors: ErrorType[] | null): void {
    let foundFormError = false;
    if (!errors) {
      return;
    }

    errors.forEach(e => {
      const el = form.get(e.field);
      if (!el) {
        return;
      }
      foundFormError = true;
      el.setErrors({
        message: e.messages[0],
      });
    });
    if (!foundFormError) {
      this.toastr.error(Object.values(errors)[0].messages[0]);
    }
  }
}

export interface ErrorType {
  __typename: 'ErrorType';
  field: string;
  messages: string[];
}
